const constants = Object.freeze({
  ADMIN: "CRMUT5022",
  USER: "CRMUT5046",
});

export default constants;
